// @ts-ignore
import packageJson from './package.json'

export const version = packageJson.version
